var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultProfileAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#AEB1B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20C19 17.2386 21.2386 15 24 15C26.7614 15 29 17.2386 29 20C29 22.7614 26.7614 25 24 25C21.2386 25 19 22.7614 19 20ZM24 23C25.6569 23 27 21.6569 27 20C27 18.3431 25.6569 17 24 17C22.3431 17 21 18.3431 21 20C21 21.6569 22.3431 23 24 23Z",
    fill: "#575F6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3431 28.3431C16.8429 29.8434 16 31.8783 16 34H18C18 32.4087 18.6321 30.8826 19.7574 29.7574C20.8826 28.6321 22.4087 28 24 28C25.5913 28 27.1174 28.6321 28.2426 29.7574C29.3679 30.8826 30 32.4087 30 34H32C32 31.8783 31.1571 29.8434 29.6569 28.3431C28.1566 26.8429 26.1217 26 24 26C21.8783 26 19.8434 26.8429 18.3431 28.3431Z",
    fill: "#575F6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileAvatar);
export default __webpack_public_path__ + "static/media/DefaultProfileAvatar.e49f72835e1423703cb8fde766a36558.svg";
export { ForwardRef as ReactComponent };